import { GameState, GAME_INIT_STATE, GAME_INIT, TableMessage, GameStateId, GameToLoad, GamesObjectType, ComponentToLoad, GameSettings, CommonGameActionProps, StreamToLoad } from './game.state';
import * as GameActions from './game.actions';
import { INIT_GAME_STATE, ITableState, ITournamentState } from '@soposopo/sopo-models';
import { Action, createReducer, on } from '@ngrx/store';

const _gameReducer = createReducer(

    GAME_INIT_STATE,

    on(
        GameActions.GameDispatcherActions.addNewGameToState,
        (state, action) => {
            const games = {...state.games};
            const gameList = state.gamesList.slice();
            const componentAlreadyPresent = () => {
                switch (action.game.componentType) {
                    case 'game':
                        return state.gamesList.filter(g => g.componentType === 'game').find((game: GameToLoad) => game.tableId === (action.game as GameToLoad).tableId);
                    case 'stream':
                    case 'clubChat':
                        return state.gamesList.find((game) => game.gameStateId === action.game.gameStateId);
                }
            }
            if (!componentAlreadyPresent()){
                if (action.game.componentType === 'game') games[action.game.gameStateId] = {...GAME_INIT};
                const game = {...action.game, toNav: action.toNav }
                gameList.push(game);
            }
            return {
                ...state,
                games: games,
                gamesList: gameList
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.resetToNavInGame,
        (state, action) => {
            const gameList = state.gamesList.slice(); // Clone the array
            const gameIndex = gameList.findIndex(game => game.gameStateId === action.gameStateId);
            if (gameIndex !== -1 && gameList[gameIndex].componentType === 'game') {
                const modifiedGame = {
                    ...gameList[gameIndex],
                    toNav: false
                };
                gameList[gameIndex] = modifiedGame;
            }
            return {
                ...state,
                gamesList: gameList,
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.removeGameFromGamesList,
        (state, action) => {
            const index = state.gamesList.findIndex( game => game.gameStateId == action.gameStateId);
            if (index > -1) action.removedGame = {...state.gamesList[index]};
            const gameList = state.gamesList.filter((_, i) => i !== index);
            return {
                ...state,
                gamesList: [...gameList],
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.removeAllGameStates,
        (state, action) => {
            const games: GamesObjectType = {};
            const gameList: ComponentToLoad[] = [];
            const remainingGames: GameStateId [] = [];
            state.gamesList.forEach((game, index) => {
                if (game.componentType === 'game') remainingGames.push(game.gameStateId)
                const currentGame = {
                    ...game,
                };
                gameList.push(currentGame);
            })
            action.remainingGames = remainingGames;
            remainingGames.forEach( gameStateId => {
                const gameState = {...GAME_INIT};
                games[gameStateId] = gameState;
            })
            return {
                ...state,
                games: games,
                gamesList: gameList,
                selectedGame: '',
                gridView: false
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.modifyGameSettings,
        (state, action) => {
            const gameList = state.gamesList.slice();
            let game = gameList.find(g => g.gameStateId === action.gameStateId && g.componentType === 'game') as GameToLoad;
            if (game) {
                const settings = {...game.settings, ...action.settings};
                game = {...game, settings};
                gameList[action.gameStateId] = game;
            }
            return {
                ...state,
                gamesList: gameList
            }
        }
    ),

    on(
        GameActions.dealerResetAction,
        (state, action) => {
            const games = {...state.games};
            if (games[action.gameStateId]) games[action.gameStateId].dealer = {... INIT_GAME_STATE};
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.timebankCountUpdated,
        (state, action) => ({
            ...state,
            timebankCount: action.count,
        })
    ),

    on(
        GameActions.GameDispatcherActions.timebankCountReset,
        (state, action) => ({
            ...state,
            timebankCount: action.count,
        })
    ),

    on(
        GameActions.GameDispatcherActions.tableDataUpdated,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                games[action.gameStateId].table = action.table,
                games[action.gameStateId].fetching = false;
                games[action.gameStateId].error = null;
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.tournamentDataUpdated,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                const tables = {...games[action.gameStateId].tournament.tables};
                games[action.gameStateId].tournament = { ...action.tournament};
                games[action.gameStateId].tournament.tables = tables;
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.tournamentTablesDataUpdated,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                games[action.gameStateId].tournament = addTablesToTournament({...state.games[action.gameStateId].tournament}, { ...action.tables});
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.dealerDataUpdated,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                games[action.gameStateId] = {
                    ...state.games[action.gameStateId],

                    dealer: updateDealer({...state.games[action.gameStateId].players}, action.game, {...state.games[action.gameStateId].dealer}, action.playerId),
                    players: updatePlayers({...state.games[action.gameStateId].players}, action.game.players),
                    fetching: false,
                    error: null,
                }
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.gameLoaded,
        GameActions.GameDispatcherActions.blindsPosted,
        GameActions.GameDispatcherActions.blindsAndAntePosted,
        GameActions.GameDispatcherActions.postDeadBlinds,
        GameActions.GameDispatcherActions.holdEmGameStarted,
        GameActions.GameDispatcherActions.shortDeckGameStarted,
        GameActions.GameDispatcherActions.omahaGameStarted,
        GameActions.GameDispatcherActions.omaha5GameStarted,
        GameActions.GameDispatcherActions.omahaHiLoGameStarted,
        GameActions.GameDispatcherActions.razzGameStarted,
        GameActions.GameDispatcherActions.studGameStarted,
        GameActions.GameDispatcherActions.studHiLoGameStarted,
        GameActions.GameDispatcherActions.playerAddedTime,
        GameActions.GameDispatcherActions.playerBetted,
        GameActions.GameDispatcherActions.playerChecked,
        GameActions.GameDispatcherActions.playerCalled,
        GameActions.GameDispatcherActions.playerFolded,
        GameActions.GameDispatcherActions.playerFoldedNoShowdown,
        GameActions.GameDispatcherActions.playerHuntedRabbit,
        GameActions.GameDispatcherActions.playerRaised,
        GameActions.GameDispatcherActions.playerFoldedByTimeout,
        GameActions.GameDispatcherActions.playerCheckedByTimeout,
        GameActions.GameDispatcherActions.playerWentAllIn,
        GameActions.GameDispatcherActions.advancedToFlop,
        GameActions.GameDispatcherActions.advancedToTurn,
        GameActions.GameDispatcherActions.advancedToRiver,
        GameActions.GameDispatcherActions.advancedToThirdStreet,
        GameActions.GameDispatcherActions.advancedToFourthStreet,
        GameActions.GameDispatcherActions.advancedToFifthStreet,
        GameActions.GameDispatcherActions.advancedToSixthStreet,
        GameActions.GameDispatcherActions.advancedToSeventhStreet,
        GameActions.GameDispatcherActions.advancedToLastManStanding,
        GameActions.GameDispatcherActions.advancedToShowdown,
        GameActions.GameDispatcherActions.advancedToPayWinner,
        GameActions.GameDispatcherActions.advancedToBadBeatJackpot,
        GameActions.GameDispatcherActions.advancedToGameOver,
        GameActions.GameDispatcherActions.updateDeltaGameState,
        (state, action) => {
            const players = action.game.players ? action.game.players : {...state.games[action.gameStateId].players};
            const games = {...state.games};
            if (games[action.gameStateId]) {
                games[action.gameStateId] = {
                    ...state.games[action.gameStateId],

                    dealer: updateDeltaDealerState(
                        {...state.games[action.gameStateId].dealer},
                        action.game,
                        action.playerId,
                    ),
                    players: updatePlayers({...state.games[action.gameStateId].players}, players),
                    fetching: false,
                    error: null,
                }
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.tableMessageDataUpdated,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                const messages = action.messages.slice();
                games[action.gameStateId] = {...games[action.gameStateId], unreadMessageCount: 0, messages}
            }
            return {
                ...state,
                games: games,
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.newTableMessageRecieved,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                const message = action.message;
                let unreadMessageCount: number | null = null;
                if(message.senderID != action.playerId) {
                    unreadMessageCount = games[action.gameStateId].unreadMessageCount + 1;
                }
                unreadMessageCount = unreadMessageCount ?? games[action.gameStateId].unreadMessageCount;
                games[action.gameStateId] = {...games[action.gameStateId], unreadMessageCount, messages: [message, ...games[action.gameStateId].messages]}
            }
            return {
                ...state,
                games: games,
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.resetUnreadTableMessagesCount,
        (state, action) => {
            const games = {...state.games};
            if(games[action.gameStateId]) {
                games[action.gameStateId] = {...games[action.gameStateId], unreadMessageCount : 0}
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.gameErrorAction,
        (state, action) => {
            const games = {...state.games};
            games[action.gameStateId].error = action.error;
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.leaveTableAction,
        (state, action) => {
            const games = {...state.games};
            if (games[action.gameStateId]) games[action.gameStateId] = {...GAME_INIT};
            return {
                ...state,
                games: games
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.toggleCard,
        (state, action) => {
            const games = {...state.games};
            const revealedHand = [...games[action.gameStateId].dealer.players[action.playerId].revealedHand];
            const index = revealedHand.indexOf(action.revealCardIndex);
            if (index >= 0) {
                revealedHand.splice(index, 1);
            } else {
                revealedHand.push(action.revealCardIndex);
            }
            games[action.gameStateId].dealer.players[action.playerId].revealedHand = revealedHand;
            return {
                ...state,
                games: games
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.handDataUpdated,
        (state, action) => {
            const games = {...state.games};
            if (games[action.gameStateId]) {
                games[action.gameStateId] = {
                    ...state.games[action.gameStateId],
                    dealer: updatePlayerHandInDealer({...state.games[action.gameStateId].dealer}, action.hand, action.playerId),
                }
            }
            return {
                ...state,
                games: games
            };
        }
    ),

    on(
        GameActions.GameDispatcherActions.setGridView,
        (state, action) => ({
            ...state,
            gridView: action.enabled,
        })
    ),

    on(
        GameActions.GameDispatcherActions.changeSelectedGame,
        (state, action) => ({
            ...state,
            selectedGame: action.gameStateId,
        })
    ),

    on(
        GameActions.GameDispatcherActions.clearGamesList,
        (state, action) => ({
            ...state,
            gamesList: [],
            selectedGame: '',
        })
    ),

    on(
        GameActions.GameDispatcherActions.changeClubId,
        (state, action) => {
            const newGameList = [...state.gamesList].map((game => {
                if (game.gameStateId === action.gameStateId && game.componentType === "game")
                    game.clubId = action.clubId;
                return game;
            }));

            return {
                ...state,
                gamesList: newGameList
            }
        }
    ),

    on(
        GameActions.GameDispatcherActions.updateGameToPreviewId,
        (state, action) => {
            const gamesList = state.gamesList.slice();
            gamesList.filter((game: StreamToLoad, index: number) => {
                const stream: StreamToLoad = {
                    ...game,
                    gameToPreviewId: action.gameToPreviewId
                }
                gamesList[index] = stream;
            })
            return {
                ...state,
                gamesList: gamesList,
            }
        }
    ),

    on(
        GameActions.tableBottomImageSet,
        (state, action) => {
            const games = {...state.games};
            games[action.gameStateId].tableBottomAreaImage = action.imageSrc;
            return {
                ...state,
                games: games
            }
        }
    ),
)

function updateDealer(player: any, game: any, dealer: any, playerId: string) {
    if (player) {
        if (Object.entries(player).length > 0) {
            const playersKey: any = Object.keys(player);
            if (playersKey) {
                playersKey.forEach((playerID) => {
                    if (game.players[playerID] && player[playerID].revealedHand.length > 0) {
                        game.players[playerID].revealedHand = [...player[playerID].revealedHand];
                    }
                });
            }
        }
    }
    if (game.players && game.players[playerId]) {
        if (dealer.players && dealer.players[playerId] && dealer.players[playerId].hand) {
            game.players[playerId].hand = [...dealer.players[playerId].hand];
        } else {
            game.players[playerId].hand = [];
        }
    }
    return game;
}

function updateDeltaDealerState(dealer: any, deltaState: any, playerId: string) {
    let updatedState = {};
    if (deltaState) {
        Object.keys(dealer).map((item) => {
            if (
                typeof deltaState[item] === 'number' ||
                typeof deltaState[item] === 'string' ||
                typeof deltaState[item] === 'boolean'
            ) {
                updatedState[item] = deltaState[item];
            } else {
                if (deltaState[item]) {
                    updatedState[item] = deltaState[item];
                } else {
                    updatedState[item] = dealer[item];
                }
            }
        });
        if (
            updatedState['players'] &&
            updatedState['players'][playerId] &&
            updatedState['players'][playerId].hand
        ) {
            if (dealer.players && dealer.players[playerId] && dealer.players[playerId].hand) {
                updatedState['players'][playerId].hand = [...dealer.players[playerId].hand];
            } else {
                updatedState['players'][playerId].hand = [];
            }
        }
    }
    if (Object.keys(updatedState).length > 0) {
        return updatedState;
    }

    return dealer;
}

function updatePlayers(player: any, players: any) {
    if (player) {
        if (Object.entries(player).length > 0) {
            const playersIDs: any = Object.keys(player);
            if (playersIDs) {
                playersIDs.forEach((playerID) => {
                    if (players[playerID] && player[playerID].revealedHand.length > 0) {
                        players[playerID].revealedHand = player[playerID].revealedHand;
                    }
                });
            }
        }
    }
    return players;
}

function updatePlayerHandInDealer(dealer: any, hand: any, playerId: string) {
    if (dealer.players && dealer.players[playerId]) {
        const handArray: any = [];
        if (hand && Object.keys(hand).length > 0) {
            Object.keys(hand).forEach((key) => {
                handArray.push(hand[key]);
            });
        }
        dealer.players[playerId]['hand'] = handArray;
    }
    return dealer;
}

function addTablesToTournament(tournament: any, tables: any) {
    const tournamentTables = { ...tournament };
    tournamentTables.tables = tables;
    return tournamentTables;
}

export function gameReducer(state: GameState, action: Action) {
    return _gameReducer(state, action);
}
